import React from "react";
import { LoginServices } from "../../services/LoginServices";
import { useNavigate } from "react-router-dom";
import LogoutIcon from '@mui/icons-material/Logout';
import SettingsIcon from '@mui/icons-material/Settings';
import {VscReferences} from "react-icons/vsc";
import {CiLock} from "react-icons/ci";
import {LogsServices} from "../../services/LogsServices";
import {sessionStore} from "../../store/sessionStore";

const DropdownLogin = ({ open }) => {
  const navigate = useNavigate();

  const handleClickLogout = async () => {
    await LogsServices.postLog(`Login: Logout usuário ${sessionStore.userId} efetuou logout`);
    LoginServices.logout();
  };

  // const handleClickConfiguration = () => {
  //   navigate("/configuration");
  // };

  const handleClickReferences = () => {
    navigate("/references");
  }

  return (
    <>
      <div className={`fixed -ml-56 md:ml-12 bottom-24 md:bottom-14 w-64 z-50 ${open ? "block" : "hidden"} `}>
        <ul className="absolute bg-white w-full shadow-lg rounded-md -bottom-12">
          <div>
            <li className="flex flex-row bg-gray-200 text-gray-500 p-2 select-none rounded-t-md">
              <SettingsIcon className="w-4 mr-2" />
              <p>Configurações</p>
              <div className="w-full flex justify-end">
                <CiLock className='text-xl text-black' />
              </div>

            </li>
          </div>
          <div>
            <li onClick={() => handleClickReferences()} className="flex flex-row cursor-pointer bg-white hover:bg-green-700 hover:text-white p-2 select-none items-center">
              <VscReferences className="w-4 mr-2" />
              <p>Referências</p>
            </li>
          </div>
          <div>
            <li onClick={handleClickLogout} className="flex flex-row cursor-pointer text-black hover:bg-rose-700 hover:text-white p-2 select-none rounded-b-md">
              <LogoutIcon className="w-4 mr-2" />
              <p className="w-4 ">Sair</p>
            </li>
          </div>
        </ul>
      </div>
    </>
  );
};
export default DropdownLogin;